import React, { ComponentProps } from 'react'
import { Text } from 'components/Text'
import { Icon } from 'components/Icon'
import { IconName } from 'components/Icon/iconNames'
import { Option } from './RadioOption.styles'

type RadioOptionOwnProps = ComponentProps<typeof Option>

export type RadioOptionProps = RadioOptionOwnProps & {
  label: string
  value: string
  icon: IconName
}

export const RadioOption = ({ label, icon, value, ...rest }: RadioOptionProps) => {
  return (
    <Option id={value} value={value} {...rest}>
      <Icon name={icon} />
      <Text
        htmlFor={value}
        as="label"
        color="tertiary-900"
        size={{ '@initial': 'small', '@bp2': 'body' }}
      >
        {label}
      </Text>
    </Option>
  )
}

RadioOption.displayName = 'RadioOption'
